import React from 'react';

const PageHeader = ({ 
  title, 
  subtitle, 
  backgroundImage = 'https://images.unsplash.com/photo-1534258936925-c58bed479fcb?w=1920&q=80',
  overlayOpacity = 0.6,
  backgroundPosition = 'center',
  backgroundSize = 'cover'
}) => {
  return (
    <section className="relative h-[34vh] md:h-[42vh] flex items-center justify-center bg-black overflow-hidden pt-20">
      {/* Background Image */}
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: `url('${backgroundImage}')`,
          backgroundPosition: backgroundPosition,
          backgroundSize: backgroundSize,
          backgroundRepeat: 'no-repeat',
        }}
      />
      
      {/* Dark Overlay */}
      <div 
        className="absolute inset-0 bg-black"
        style={{ opacity: overlayOpacity }}
      />
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <h1 
          className="text-white uppercase mb-4"
          style={{
            fontFamily: "'BebasNeue-Book', sans-serif",
            fontSize: "clamp(50px, 10vw, 120px)",
            letterSpacing: "-2px",
            lineHeight: "1"
          }}
        >
          {title}
        </h1>
        
        {subtitle && (
          <p 
            className="page-header-subtitle text-white text-base md:text-lg max-w-2xl mx-auto"
            style={{
              fontFamily: "'BebasNeue-Book', sans-serif",
              letterSpacing: "1px"
            }}
          >
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
